import { render, staticRenderFns } from "./sky-thumbnail.vue?vue&type=template&id=768e85b8&scoped=true"
import script from "./sky-thumbnail.vue?vue&type=script&lang=js"
export * from "./sky-thumbnail.vue?vue&type=script&lang=js"
import style0 from "./sky-thumbnail.vue?vue&type=style&index=0&id=768e85b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768e85b8",
  null
  
)

export default component.exports